import { print } from "./print";

export const awb = { print };
